import Component from '../inherited/Component';
import Marquee3k from 'marquee3000';

export default class Marquee extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx);
    }

    async mount() {
        this.Marquee3k = await import('marquee3000');
        this.Marquee3k = this.Marquee3k.default;

        window.addEventListener(
            'resize',
            (e) => {
                this.Marquee3k.refreshAll();
            },
            { passive: true }
        );

        document.addEventListener('shopify:section:load', (e) => {
            this.marqueeInit();
        });

        setTimeout(() => {
            this.marqueeInit();
            this.Marquee3k.refreshAll();
        }, 500);
    }

    marqueeInit() {
        this.Marquee3k.init({
            selector: 'marquee-bar',
        });
    }
}
